module.exports = __webpack_public_path__ + "../resources/img/ic_complete_number_2_lt.17540841.svg";